import { render, staticRenderFns } from "./defaultSection.vue?vue&type=template&id=32ea7238&scoped=true&"
import script from "./defaultSection.vue?vue&type=script&lang=js&"
export * from "./defaultSection.vue?vue&type=script&lang=js&"
import style0 from "./defaultSection.vue?vue&type=style&index=0&id=32ea7238&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32ea7238",
  null
  
)

component.options.__file = "defaultSection.vue"
export default component.exports